import getWithToken from './base/get-with-token'

const getCustomersFilterOptions = getWithToken(`/filter-data/customer`)

export default getCustomersFilterOptions